// extracted by mini-css-extract-plugin
module.exports = {"stedintroVideoBlokk":"dh-sk-stedintroVideoBlokk","stedintroVideoBlokk__video":"dh-sk-stedintroVideoBlokk__video","stedintroVideoBlokk__anim":"dh-sk-stedintroVideoBlokk__anim"};